module.exports = __webpack_public_path__ + "media/images/samples/home/news/f2-27705d898bfb499784b8b03acb19d671.png";